import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { bankDetailsValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextInput";

const BankDetails = (props: any) => {
  const { id, bankData } = props;
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    clearErrors,
    getValues,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(bankDetailsValidationForm),
    defaultValues: async () => {
      return {
        ...bankData[0],
        payment_detail: bankData[0]?.payment_detail || {},
      };
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["bank-details"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.BANK_DETAIL}`;
    const payment_detail = { ...values.payment_detail };
    Object.keys(payment_detail || {}).forEach(
      (key) => !payment_detail[key] && delete payment_detail[key]
    );
    let formData = {
      object_id: id,
      ...values,
      payment_detail,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data: any) =>
        handleUpdateProfile(data, setError)
      )}
      autoComplete="off"
    >
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Account Name"}
          register={register("beneficiary")}
          errors={errors?.beneficiary}
        />
        {/* <NumberField
          value={getValues("account_number")}
          register={register("account_number")}
          errors={errors?.account_number}
          label={"Account No."}
          setValue={setValue}
          clearErrors={clearErrors}
        /> */}
        <TextField
          label={"Account Number"}
          register={register("account_number")}
          errors={errors?.account_number}
        />
        <TextField
          label={"Swift Code"}
          register={register("code")}
          errors={errors?.code}
        />
        <TextField
          label={"Bank Name"}
          register={register("bank_name")}
          errors={errors?.bank_name}
        />
        <TextField
          label={"Address"}
          register={register("address")}
          errors={errors?.address}
        />
        <TextField
          label={"FonePay"}
          register={register("payment_detail.fonepay")}
          errors={errors?.payment_detail}
        />

        <TextField
          label={"eSewa"}
          register={register("payment_detail.esewa")}
          errors={errors?.payment_detail}
        />

        <TextField
          label={"Khalti"}
          register={register("payment_detail.khalti")}
          errors={errors?.payment_detail}
        />
      </div>

      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[100px] mr-4`}>
          <Button label={"Submit"} isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default BankDetails;
